export function isAzetShop() {
  return (
    typeof window !== "undefined" &&
    window.location.host === "azet-tickets.ventiq.io"
  );
}
